/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Submitticket_Modal_Subtitle1Inputs */

const en_support_submitticket_modal_subtitle1 = /** @type {(inputs: Support_Submitticket_Modal_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit ticket to the investor relations team`)
};

/**
* | output |
* | --- |
* | "Submit ticket to the investor relations team" |
*
* @param {Support_Submitticket_Modal_Subtitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const support_submitticket_modal_subtitle1 = /** @type {((inputs?: Support_Submitticket_Modal_Subtitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Submitticket_Modal_Subtitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_support_submitticket_modal_subtitle1(inputs)
});
export { support_submitticket_modal_subtitle1 as "support_submitTicket_modal_subtitle" }